import { TFunction } from '@lyearn/i18n';
import { Box, IconButton, IconButtonProps, Tooltip } from '@lyearn/ui';
import { EmojiEnum } from '@/features/feedback/components/MoodEmojiList/consts';
import { FeedbackResponseInput } from '@/types/schema';

import { AIFeedbackReactionType } from '../../consts';

export const renderButton = ({
  t,
  reaction,
  onClick,
  disabled,
  emojiResponse,
  buttonSize = 's',
}: {
  t: TFunction;
  reaction: AIFeedbackReactionType;
  onClick: (id: EmojiEnum, showDialog?: boolean) => void;
  disabled?: boolean;
  emojiResponse: FeedbackResponseInput | null;
  buttonSize?: IconButtonProps['size'];
}) => {
  if (disabled) {
    return (
      <Box className="p-4">
        <reaction.Icon
          className={buttonSize === 'xs' ? 'h-16 w-16' : 'h-20 w-20'}
          fillColorToken={
            emojiResponse?.response === reaction.id ? 'icon-active' : 'icon-secondary'
          }
        />
      </Box>
    );
  }

  return (
    <Tooltip placement="top" title={t(reaction.labelKey)}>
      <Box>
        <IconButton
          Icon={reaction.Icon}
          appearance="secondary"
          aria-label={t(reaction.ariaLabelKey)}
          className="flex-shrink-0"
          shape="square"
          size={buttonSize}
          variant="ghost"
          onClick={() => onClick(reaction.id, reaction.showPopover)}
        />
      </Box>
    </Tooltip>
  );
};
